export const NO_INJURIES = 2;
export const YES_INJURIES = 1;



/** WEBPACK FOOTER **
 ** ./src/constants/InjurySummaryConstants.js
 **/